import React, { Component } from 'react'
import cx from 'classnames'
import FontAwesome from 'react-fontawesome'

import './style.css'

export default class IconDataView extends Component {
  render() {
    const { name, children } = this.props
    return (
      <div className={cx('IconData', { fullWidth: this.props.fullWidth })}>
        <div className="icon">
          <FontAwesome name={name} />
        </div>
        <div className="child">{children}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/IconData/IconDataView.js